import * as React from 'react';
import { Navbar as NavbarStrap } from 'reactstrap';
import { IComponentProps } from '../../common';

export interface INavbarProps extends IComponentProps {
    light?: boolean;
    dark?: boolean;
    inverse?: boolean;
    full?: boolean;
    fixed?: string;
    sticky?: string;
    color?: string;
    role?: string;
    tag?: React.ReactType;
    className?: string;
    toggleable?: boolean | string;
    expand?: boolean | string;
}

export const Navbar: React.FC<INavbarProps> = props => {
    return <NavbarStrap {...props} />;
};
